import React, { createContext, useContext, useEffect, useState } from 'react';

interface ViewportContextType {
  isMobile: boolean;
}

const ViewportContext = createContext<ViewportContextType>({ isMobile: false });

export const ViewportProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1280);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1280);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return <ViewportContext.Provider value={{ isMobile }}>{children}</ViewportContext.Provider>;
};

export const useViewport = () => useContext(ViewportContext);
